export const ALL_TAGS_KEY = 'ALL';
export const YAHOO_TAGS_KEY = 'YAHOO';
export const OTHER_TAGS_KEY = 'OTHER';
export const DEFAULT_TAGS = [];
